<template>
  <campsite-subsection
    name="description"
    class="cs-description"
    :scroll-offset="-75"
    :open="open"
    @subsection-closed="$emit('subsection-closed')"
  >
    <template #subsection-open-txt>
      <translate
        class="subsection-open-txt"
        :data-sctrack="`${String($route.name)}--CampsiteDescriptionDesktop-read-more`"
      >
        Read more
      </translate>
    </template>
    <template #contents>
      <div class="content-inner">
        <span v-if="campsite.nutshells.length || campsite.description">
          <pu-nutshells
            v-if="campsite.nutshells.length"
            :nutshells="campsite.nutshells"
            :with-jump-link="false"
            class="nutshells"
            :data-sctrack="`${String($route.name)}--CampsiteDescriptionDesktop-nutshells`"
          />

          <campsite-description-text
            v-if="campsite.description"
            :description-needs-translation="
              campsite.descriptionNeedsTranslation
            "
            :description="campsite.description"
          />
        </span>
        <campsite-description :campsite="campsite" />
      </div>
    </template>
  </campsite-subsection>
</template>
<script lang="ts">
import { CampsiteDetails } from '../types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CampsiteDescriptionDesktop extends Vue {
  @Prop()
  campsite: CampsiteDetails

  @Prop({ default: false })
  open: boolean
}

export default toNative(CampsiteDescriptionDesktop)
</script>

<style scoped>
/* desktop only */
.cs-description.campsite-subsection {
  border: none;
  margin: auto;
  max-width: var(--page-width-max);
  padding: 1.5em var(--page-width-padding) 0;
  width: 100%;
}

.cs-description.campsite-subsection :deep(footer) {
  background: linear-gradient(0deg, #fff 0%, rgba(255, 255, 255, 0) 100%);
  display: flex;
  inset: auto 0 0 0;
  padding-top: 5em;
  position: absolute;
  pointer-events: none;
}

.cs-description.campsite-subsection :deep(footer label) {
  border-radius: 3em;
  border: 0.3em solid var(--colour-dark-blue);
  color: var(--colour-dark-blue);
  display: inline-flex;
  margin: 0 auto;
  padding: 0.35em 0.75em;
  width: auto;
  cursor: pointer;
  flex-direction: row-reverse;
  background: white;
  font-weight: bold;
  pointer-events: all;
}

.cs-description.campsite-subsection :deep(footer label:hover),
.cs-description.campsite-subsection :deep(footer label:active) {
  background: var(--colour-dark-blue);
  color: white;
}

.cs-description.campsite-subsection :deep(footer .caret) {
  margin: 0 0 0 0.4em;
}

.cs-description.campsite-subsection :deep(footer label:hover .caret span),
.cs-description.campsite-subsection
  :deep(footer label:focus-visible .caret span) {
  border-color: white;
  background: white;
}

.cs-description.campsite-subsection :deep(header) {
  display: none;
}

.cs-description :deep(.subsection-content) {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s ease-out;
  max-height: none;
}

.cs-description :deep(.show-checkbox:checked ~ .subsection-content) {
  grid-template-rows: 1fr;
}

.content-inner {
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 5em;
  min-height: 13em;
  padding-bottom: 4em;
}

.cs-description :deep(.campsite-description-text) {
  margin: 1.4em 0 1.4em;
  font-size: inherit;
  line-height: 1.4;
}

.cs-description :deep(.site-categories p),
.cs-description :deep(.notices-title),
.cs-description :deep(.tourist-board p),
.cs-description :deep(.languages-spoken p:first-child) {
  font-size: inherit;
  color: var(--colour-dark-blue);
  font-weight: bold;
  margin: 0 0 0.5em 0;
}

.cs-description :deep(.site-details .open-status) {
  font-size: inherit;
  font-weight: bold;
}

.cs-description :deep(.site-details.top) {
  display: flex;
  justify-content: space-between;
}

.cs-description :deep(.site-details.bottom) {
  margin: 1.75em 0 0.75em;
}

.cs-description :deep(.site-details.bottom p) {
  font-size: inherit;
}

.cs-description :deep(.notices-title) {
  margin: 0.5em 0 0.75em;
  display: block;
}

.cs-description :deep(.campsite-notices li) {
  line-height: 1.4;
  margin-bottom: 0.7em;
}

.cs-description :deep(.site-categories) {
  margin-bottom: 0.75em;
}

.cs-description :deep(.category-icons) {
  gap: 0.35em;
}

.cs-description :deep(.category-icons .count) {
  margin: 0.25em 0 0 0;
}

.cs-description :deep(.category-icon) {
  width: auto;
  height: 1.8em;
}

.cs-description :deep(.star-icon) {
  width: 2em;
  margin-right: 0.4em;
}

.cs-description :deep(.site-awards img) {
  max-width: 8em;
  max-height: 8em;
}

.cs-description :deep(.basic-listing .site-details.bottom) {
  margin-top: 0;
}
</style>
